import { useUserContext } from '@fortem-monorepo/react-spa'
import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { SendBespokeInvoiceForm } from '@/components/forms/SendBespokeInvoiceForm/SendBespokeInvoiceForm'
import { SendBespokeInvoiceFormFields } from '@/components/forms/SendBespokeInvoiceForm/SendBespokeInvoiceFormFields'

export interface SendBespokeInvoiceModalProps extends DialogProps {}

export const SendBespokeInvoiceModal: React.FC<SendBespokeInvoiceModalProps> = ({ ...props }) => {
  const { user } = useUserContext()

  return (
    <Dialog {...props}>
      <DialogContent>
        <SendBespokeInvoiceForm>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Send Bespoke Invoice</DialogTitle>
                  <DialogDescription>Email will be sent to {user.user?.email}</DialogDescription>
                </DialogHeader>
                <div className="my-6">
                  <SendBespokeInvoiceFormFields />
                </div>
                <DialogFooter>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </SendBespokeInvoiceForm>
      </DialogContent>
    </Dialog>
  )
}
